function scoreBtn(color, bg) { return { width: '38px', height: '38px', borderRadius: '10px', border: '0.5px solid ' + color, background: bg, color, fontSize: '22px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1, flexShrink: 0 } }
function evBtn(color, bg) { return { padding: '11px 6px', borderRadius: '10px', border: '0.5px solid ' + color, background: bg, color, fontSize: '12px', cursor: 'pointer', textAlign: 'center', fontWeight: '500', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', whiteSpace: 'pre-line' } }

export default function ScoreTab({
  fixture, isTracker, trackedByName,
  isHurl, allowsTwoPointFootball, setPieceLabel, koLabelPlural,
  score, scorerList, ourGoalsPlay, ourPointsPlay, oppGoalsPlay, oppPointsPlay,
  ourWides, oppWides, ourFortyFives, oppFortyFives,
  ourKOWon, ourKOLost, oppKOWon, oppKOLost,
  freesWon, freesConceded,
  handleScorePress, handleOppScorePress, logEvent, undoLast,
  setModal, setUndoModal, setMultiSubMode, setActiveTab,
  setSubStep, setSubOff, setSubInitiatedBySub,
}) {
  if (!fixture) return null
  return (
    <div>
      {!isTracker && (
        <div style={{ background: '#FFF9E6', border: '0.5px solid #FFD700', padding: '8px 14px', fontSize: '12px', color: '#854F0B', textAlign: 'center' }}>
          👁 View only — {trackedByName} is tracking this match
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1px 1fr', padding: '12px 12px 6px', opacity: isTracker ? 1 : 0.5, pointerEvents: isTracker ? 'auto' : 'none' }}>
        <div>
          <p style={{ fontSize: '10px', color: '#888', fontWeight: '500', textAlign: 'center', marginBottom: '10px' }}>
            {fixture.squads?.name || 'Us'}
          </p>
          {[
            { type: 'goal', label: 'Goal', undo: 'undo_goal' },
            { type: 'point', label: 'Point', undo: 'undo_point' },
            ...(!isHurl && allowsTwoPointFootball ? [{ type: 'twopoint', label: '2-Point', undo: 'undo_twopoint' }] : []),
          ].map(({ type, label, undo }) => (
            <div key={type} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', gap: '4px', padding: '0 4px' }}>
              <button onClick={() => handleScorePress(type)} style={scoreBtn('#185FA5', '#E6F1FB')}>+</button>
              <span style={{ flex: 1, fontSize: '13px', color: '#333', textAlign: 'center' }}>{label}</span>
              <button onClick={() => logEvent(undo)} style={scoreBtn('#888', '#f8f8f8')}>−</button>
            </div>
          ))}
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', gap: '4px', padding: '0 4px' }}>
            <button onClick={() => setModal('ourWide')} style={scoreBtn('#854F0B', '#FAEEDA')}>+</button>
            <span style={{ flex: 1, fontSize: '12px', color: '#333', textAlign: 'center' }}>
              Wide ({ourWides}){'\n'}<span style={{ fontSize: '10px', color: '#888' }}>{setPieceLabel}: {ourFortyFives}</span>
            </span>
            <button onClick={() => undoLast('wide_us')} style={scoreBtn('#888', '#f8f8f8')}>−</button>
          </div>
        </div>

        <div style={{ background: '#e0e0e0', margin: '28px 0 4px' }} />

        <div>
          <p style={{ fontSize: '10px', color: '#888', fontWeight: '500', textAlign: 'center', marginBottom: '10px' }}>
            {fixture.opponent}
          </p>
          {[
            { type: 'opp_goal', label: 'Goal', undo: 'undo_opp_goal' },
            { type: 'opp_point', label: 'Point', undo: 'undo_opp_point' },
            ...(!isHurl && allowsTwoPointFootball ? [{ type: 'opp_twopoint', label: '2-Point', undo: 'undo_opp_twopoint' }] : []),
          ].map(({ type, label, undo }) => (
            <div key={type} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', gap: '4px', padding: '0 4px' }}>
              <button onClick={() => handleOppScorePress(type)} style={scoreBtn('#A32D2D', '#FCEBEB')}>+</button>
              <span style={{ flex: 1, fontSize: '13px', color: '#333', textAlign: 'center' }}>{label}</span>
              <button onClick={() => logEvent(undo)} style={scoreBtn('#888', '#f8f8f8')}>−</button>
            </div>
          ))}
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', gap: '4px', padding: '0 4px' }}>
            <button onClick={() => setModal('oppWide')} style={scoreBtn('#888', '#f8f8f8')}>+</button>
            <span style={{ flex: 1, fontSize: '12px', color: '#333', textAlign: 'center' }}>
              Wide ({oppWides}){'\n'}<span style={{ fontSize: '10px', color: '#888' }}>{setPieceLabel}: {oppFortyFives}</span>
            </span>
            <button onClick={() => undoLast('wide_opp')} style={scoreBtn('#888', '#f8f8f8')}>−</button>
          </div>
        </div>
      </div>

      <div style={{ height: '0.5px', background: '#e0e0e0', margin: '2px 12px' }} />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px', padding: '8px 12px', opacity: isTracker ? 1 : 0.5, pointerEvents: isTracker ? 'auto' : 'none' }}>
        <button onClick={() => setModal('ourKickout')} style={evBtn('#3B6D11', '#EAF3DE')}>
          Our {koLabelPlural} ▾{'\n'}<span style={{ fontSize: '10px' }}>{ourKOWon}W {ourKOLost}L</span>
        </button>
        <button onClick={() => setModal('freeWon')} style={evBtn('#0F6E56', '#E1F5EE')}>
          Free Won ▾{'\n'}<span style={{ fontSize: '10px' }}>{freesWon} won · {freesConceded} con</span>
        </button>
        <button onClick={() => setModal('oppKickout')} style={evBtn('#888', '#f8f8f8')}>
          Opp {koLabelPlural} ▾{'\n'}<span style={{ fontSize: '10px' }}>We Won {oppKOLost} · We Lost {oppKOWon}</span>
        </button>
        <button onClick={() => setModal('freeConceded')} style={evBtn('#888', '#f8f8f8')}>Free Conceded ▾</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '6px', padding: '0 12px 6px', opacity: isTracker ? 1 : 0.5, pointerEvents: isTracker ? 'auto' : 'none' }}>
        <button onClick={() => setModal('card')} style={evBtn('#854F0B', '#FAEEDA')}>🟨 Card</button>
        <button onClick={() => { setSubStep(1); setSubOff(null); setSubInitiatedBySub(false); setModal('sub') }} style={evBtn('#533AB7', '#EEEDFE')}>🔄 Sub</button>
        <button onClick={() => setUndoModal(true)} style={evBtn('#A32D2D', '#FCEBEB')}>↩ Undo</button>
        <button onClick={() => setModal('opp_card')} style={evBtn('#888', '#f8f8f8')}>🟨 Opp Card</button>
        <button onClick={() => { setMultiSubMode(true); setActiveTab('pitch') }} style={evBtn('#533AB7', '#EEEDFE')}>⇄⇄ Multi-Sub</button>
      </div>

      {scorerList.length > 0 && (
        <div style={{ borderTop: '0.5px solid #e0e0e0', padding: '8px 12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px', flexWrap: 'wrap', gap: '4px' }}>
            <p style={{ fontSize: '10px', color: '#888', letterSpacing: '0.3px', fontWeight: '500' }}>SCORERS</p>
            <div style={{ fontSize: '10px', color: '#555', textAlign: 'right' }}>
              <span style={{ fontWeight: '600', color: '#185FA5' }}>{score.hg}-{String(score.hp).padStart(2, '00')}</span>
              <span style={{ color: '#888', marginLeft: '4px' }}>| Play: {ourGoalsPlay}-{String(ourPointsPlay).padStart(2, '00')}</span>
              <span style={{ color: '#aaa', margin: '0 4px' }}>vs</span>
              <span style={{ fontWeight: '600', color: '#A32D2D' }}>{score.ag}-{String(score.ap).padStart(2, '00')}</span>
              <span style={{ color: '#888', marginLeft: '4px' }}>| Play: {oppGoalsPlay}-{String(oppPointsPlay).padStart(2, '00')}</span>
            </div>
          </div>
          {scorerList.map((s, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '3px 0', borderBottom: '0.5px solid #f5f5f5' }}>
              <span style={{ fontSize: '13px', flex: 1, color: '#333' }}>{s.name}</span>
              <span style={{ fontSize: '13px', fontWeight: '500', color: '#185FA5' }}>
                {s.goals > 0 ? s.goals + '-' + String(s.points).padStart(2, '00') : '0-' + String(s.points).padStart(2, '00')}
              </span>
              <span style={{ fontSize: '11px', color: '#888', minWidth: '45px', textAlign: 'right' }}>
                Play: {s.goalsPlay > 0 ? s.goalsPlay + '-' + String(s.pointsPlay).padStart(2, '00') : '0-' + String(s.pointsPlay).padStart(2, '00')}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}